import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'

export default function ClientSelect(props) {
  const { clientType, onChange, onNodeChange } = props
  const [selectedNode, setSelectedNode] = React.useState(null)
  const debounceTimeoutRef = React.useRef(null)

  const fetch = async where => {
    const { clients } = await fetchQuery(
      graphql`
        query ClientSelectQuery($where: ClientWhere) {
          clients(where: $where, first: 10, orderBy: [name], order: ASC) {
            edges {
              node {
                id
                code
                name
                type
                location {
                  name
                  id
                }
              }
            }
          }
        }
      `,
      { where }
    )

    const getText = node => {
      let text = node.name
      if (node.code) text = `${node.code} - ${text}`
      if (node.location.name) text = `${text} - ${node.location.name}`
      return text
    }

    return clients.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: getText(node),
      node // Añadimos el nodo completo aquí
    }))
  }

  const getBaseWhereConditions = () => {
    const baseConditions = []

    if (clientType) {
      baseConditions.push({
        or: [
          { type: { eq: clientType } },
          { type: { is: null } },
        ],
      })

      if (clientType !== 'CORPORATE') {
        baseConditions.push({
          locationId: { ne: '56979a57-01bd-4b37-abe6-b32d1a150c58' }
        })
      }
    }

    return baseConditions
  }

  // Limpiar el timeout al desmontar el componente
  React.useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current)
      }
    }
  }, [])

  const handleChange = async (value) => {
    // Primero llamamos a onChange con el ID para mantener compatibilidad
    if (onChange) {
      onChange(value)
    }

    // Si hay onNodeChange, buscamos los datos completos del cliente
    if (onNodeChange) {
      try {
        const where = {
          and: [
            { id: { eq: value } },
            ...getBaseWhereConditions()
          ],
        }

        const options = await fetch(where)
        if (options.length > 0) {
          const selectedNode = options[0].node
          setSelectedNode(selectedNode)
          onNodeChange(selectedNode)
        }
      } catch (error) {
        console.error('Error fetching client details:', error)
      }
    }
  }

  return (
    <Select
      {...props}
      onChange={handleChange}
      getByValue={value => {
        const where = {
          and: [
            { id: { eq: value } },
            ...getBaseWhereConditions()
          ],
        }

        return fetch(where)
      }}
      loadOptions={searchQuery => {
        return new Promise((resolve) => {
          // Limpiar el timeout anterior si existe
          if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current)
          }

          // Crear un nuevo timeout
          debounceTimeoutRef.current = setTimeout(() => {
            const conditions = [{ name: { iLike: `%${searchQuery}%` } }]

            if (!isNaN(parseInt(searchQuery))) {
              conditions.push({ code: { eq: `${searchQuery}` } })
            }

            const where = {
              and: [
                { or: conditions },
                ...getBaseWhereConditions()
              ],
            }

            fetch(where).then(resolve)
          }, 300) // 300ms de delay
        })
      }}
    />
  )
}

ClientSelect.defaultProps = {
  label: 'Cliente',
  placeholder: 'Cliente',
  loadOnMount: false,
}